import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getReportList = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/configuration-reports/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSingleReportChecks = ({
  params = {},
  version = 'v1',
  categoryIdentifier,
  identifier,
} = {}) =>
  client
    .request({
      url: `${version}/configuration-reports/${categoryIdentifier}/checks/${identifier}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
